module.exports = __webpack_public_path__ + "img/bus_feature_01.eb47ed00.jpg";